module.exports = __webpack_public_path__ + "img/pic_MiaoliCounty.a8a352b1.jpg";